import { PartialFranchiseEnum } from '@insurance/api/requests'
import { RadioCardGroup } from '@insurance/components'
import { useValidationsField } from '@insurance/hooks'
import { Form } from 'antd'
import { useTranslation } from 'react-i18next'

import { useCascoInsuranceValues } from './CascoInsuranceContext'
import { enableFranchise, formProps } from './utils'

export const Franchise = () => {
  const { t } = useTranslation()
  const { franchiseProps, vehicleCategoryProps, insurancePackageProps } =
    formProps(t)
  const { required } = useValidationsField()
  const { isEditable } = useCascoInsuranceValues()

  const vehicleCategory = Form.useWatch(vehicleCategoryProps.name, {
    preserve: true
  })

  const insurancePackage = Form.useWatch(insurancePackageProps.name, {
    preserve: true
  })

  const options = Object.values(PartialFranchiseEnum).map((value) => ({
    label: t(value),
    value,
    colProps: { xs: 24, lg: 8 }
  }))

  const showFranchise = enableFranchise(vehicleCategory, insurancePackage)

  if (!showFranchise) return null

  return (
    <Form.Item {...franchiseProps} rules={[required]}>
      <RadioCardGroup disabled={isEditable} options={options} />
    </Form.Item>
  )
}
